import { collection, doc, getDocs, getFirestore, orderBy, setDoc, query, limit, where } from "firebase/firestore";
import { DateTime, Interval } from "luxon";
import { Vacation } from "../types/Vacation";
import { RequestStatus } from "../types/Type";
import vacationRequestConverter from "../converters/vacationRequestConverter";

export const updateVacation = async (vacation: Vacation) => {
  let status = vacation.status;

  const today = DateTime.utc();
  const start = DateTime.fromFormat(vacation.dateStart, 'yyyyMMdd');
  const end = DateTime.fromFormat(vacation.dateEnd, 'yyyyMMdd');
  if (vacation.requestStatus === 'Approved') {
    if (today > start) {
      status = 'In Progress';
      if (today > end) {
        status = 'Completed';
      }
    }
  }

  const db = getFirestore();
  await setDoc(
    doc(db, `Employees/${vacation.idNumber}/Vacations/${vacation.id}`),
    { 
      dateStart: vacation.dateStart,
      dateEnd: vacation.dateEnd,
      status
    },
    { merge: true }
  );

  if (status === 'In Progress') {
    await setDoc(
      doc(db, `Employees/${vacation.idNumber}`),
      { 
        status: 'On Vacation'
      },
      { merge: true }
    );
  }

  return status;
};

export const updateVacationRequestStatus = async (vacation: Vacation, requestStatus: RequestStatus) => {
  const db = getFirestore();

  await setDoc(
    doc(db, `Employees/${vacation.idNumber}/Vacations/${vacation.id}`),
    { requestStatus, dateResponded: DateTime.utc().toISO() },
    { merge: true }
  );
};